import { EmergencyLoginComponent } from './component/emergency-login/emergency-login.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/modules/shared.module';
import { AuthenticationService } from '@app/core/auth/authentication.service';
import { QRCodeModule } from 'angularx-qrcode';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { NgxCaptchaModule } from 'ngx-captcha';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CertificatesModule } from '@app/certificates/certificates.module';
import { EmergencyService } from '@app/core/auth/component/emergency-login/emergency-login.service';
import { LocalStorageService, SessionStorageService } from '@app/core';
import { CqesLoginComponent } from './component/login/cqes-login/cqes-login.component';
import { BusinessLoginComponent } from './component/business-login/business-login.component';
import { BusinessModule } from '@app/business/business.module';
import { BissDialogComponent } from './component/biss-dialog/biss-dialog.component';
import { OpenBissComponent } from './component/open-biss/open-biss.component';
import { NoActiveCertificatesFoundComponent } from './component/emergency-login/error-response-view/no-active-certificates-found.component';
// import { TranslateService } from '@ngx-translate/core';

@NgModule({
    imports: [
        SharedModule,
        MatDialogModule,
        MatButtonModule,
        MatDividerModule,
        QRCodeModule,
        FormsModule,
        ReactiveFormsModule,
        NgxCaptchaModule,
        // TranslateService
    ],
    declarations: [EmergencyLoginComponent, NoActiveCertificatesFoundComponent, CqesLoginComponent, BusinessLoginComponent, BissDialogComponent, OpenBissComponent],
    exports: [MatDialogModule, EmergencyLoginComponent, CqesLoginComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        AuthenticationService,
        CertificatesModule,
        BusinessModule,
        EmergencyService,
        LocalStorageService,
        SessionStorageService
    ],
    entryComponents: [],
})
export class AuthModule { }
